import { type LineSymbol } from '@ikegps/core-api';
import { m, type MithrilVNode } from '../mithril';
import { lineSymbolDecor, lineSymbolStrokeNodes, swatchPath } from './line.symbol.render';

export interface LineSwatchAttrs {
	symbol: LineSymbol | null;
	width?: number;
	height?: number;
}

export const LineSwatch = {
	view(attrs: LineSwatchAttrs): MithrilVNode {
		const { symbol } = attrs;
		const width = attrs.width ?? 48;
		const height = attrs.height ?? 18;

		if (symbol == null) {
			return m('svg', { width, height });
		}

		const path = swatchPath(width, height);
		const decor = lineSymbolDecor(path, symbol, 'sw');

		return m('svg', { width, height, style: 'overflow: visible;' }, [
			...lineSymbolStrokeNodes(path, symbol, decor.gaps, 'sw'),
			...decor.nodes,
		]);
	},
};
